import PropTypes from "prop-types";
import ResetScopeDialog from "./ResetScopeDialog";
export default function ResetAllReadersDialog({
  open,
  onClose,
  onConfirm,
  readerGroups,
  resetAllLoading = false,
}) {
  return (
    <ResetScopeDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Reinicio general de readers"
      scope="Todos los grupos"
      readers={readerGroups.flatMap((group) => group.readers || [])}
      loading={resetAllLoading}
    />
  );
}
ResetAllReadersDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  readerGroups: PropTypes.array.isRequired,
  resetAllLoading: PropTypes.bool,
};
